export const listTindakLanjut = [
  { id: 1, nama: "Kontrol ke klinik" },
  { id: 2, nama: "Kontrol di FKTP" },
  { id: 3, nama: "Kontrol/ Kembali ke RS" }
];

export const caraPulangOptions = [
  { id: 1, name: "Pulang" },
  { id: 2, name: "Dirujuk" },
  { id: 3, name: "Pulang Paksa" },
  { id: 4, name: "Meninggal" },
  { id: 5, name: "Rawat Inap" }
];
export const kondisiPulangOptions = [
  { id: 1, name: "Membaik" },
  { id: 2, name: "Masih Sakit" }
  // { id: 3, name: "Meninggal" },
];
export const alasanRujukanOptions = [
  { id: 1, name: "Sub-spesialistik" },
  { id: 2, name: "Fasilitas" },
  { id: 3, name: "Tempat Penuh" },
  { id: 4, name: "Permintaan Sendiri/ Keluarga" },
  { id: 5, name: "Lainnya" }
];
export const terapiTLOptions = [
  { id: 1, name: "Preventif" },
  { id: 2, name: "Kuratif" },
  { id: 3, name: "Paliatif" },
  { id: 4, name: "Rehabilitatif" }
];

export const intervensiEwsOptions = [
  {
    id: 1,
    title: "Risiko Ringan",
    level: "rendah",
    color: "amber",
    text: `Asesmen segera oleh perawat senior, eskalasi perawatan dan monitoring per 4 - 6 jam, jika diperlukan konsultasi ke dokter jaga (residence senior)`
  },
  {
    id: 2,
    title: "Risiko Sedang",
    level: "sedang",
    color: "orange darken-1",
    text: `Assesmen segera oleh dokter jaga (residence senior) (respon segera, maksimal 5 menit).\r\nKonsultasi dpjp dan spesialis terkait, eskalasi perawatan dan monitoring tiap jam.\r\nPertimbangkan perawatan di HCU`
  },
  {
    id: 3,
    title: "Risiko Tinggi",
    level: "tinggi",
    color: "red",
    text: `Resusitasi dan monitoring secara kontinyu oleh dokter jaga dan perawat senior.\r\nPanggil tim sekunder (777/888, respon maksimal 10 menit)\r\nInformasikan dan konsultasikan ke DPJP`
  },
  {
    id: 666,
    title: "HENTI NAFAS/ JANTUNG",
    level: "blue",
    color: "blue",
    text: `Lakukan RJP\r\nAktivasi henti jantung (666), respon tim primer segera maksimal 5 menit`
  }
];
